import { render, staticRenderFns } from "./Deny.vue?vue&type=template&id=e5564aca&scoped=true"
import script from "./Deny.vue?vue&type=script&lang=ts"
export * from "./Deny.vue?vue&type=script&lang=ts"
import style0 from "./Deny.vue?vue&type=style&index=0&id=e5564aca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5564aca",
  null
  
)

export default component.exports